import React, { useState, useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { clearGeneralError, forgotPasswordAsync } from './authSlice'
import RainmakersLogo from '../../components/general/RainmakersLogo'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [emailSent, setEmailSent] = useState(false)
  const { generalError } = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const history = useHistory()

  const onSubmit = async (e) => {
    e.preventDefault()
    const result = await dispatch(forgotPasswordAsync({ email }))
    if (forgotPasswordAsync.fulfilled.match(result)) {
      setEmailSent(true)
    }
  }

  useEffect(() => {
    return () => {
      if (generalError) {
        dispatch(clearGeneralError())
      }
    }
    // eslint-disable-next-line
  }, [])

  if (emailSent) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 px-6 lg:px-8">
        <div className="mx-auto w-full max-w-lg">
          <RainmakersLogo />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Check your email</h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            We've sent a password reset link to {email}
          </p>
        </div>

        <div className="mt-8 mx-auto w-full max-w-lg">
          <div className="bg-white py-8 shadow rounded-lg px-10">
            <Link
              to="/signin"
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-purple-450 hover:bg-purple-450 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-450"
            >
              Back to sign in
            </Link>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 px-6 lg:px-8">
      <div className="mx-auto w-full max-w-lg">
        <RainmakersLogo />
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Forgot Password</h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Enter your email to receive a link to reset your password.
        </p>
      </div>

      <div className="mt-8 mx-auto w-full max-w-lg">
        <div className="bg-white py-8 shadow rounded-lg px-10">
          <form className="space-y-6" onSubmit={onSubmit}>
            {generalError && (
              <div className="rounded-md bg-red-50 p-4">
                <div className="flex">
                  <div className="ml-3">
                    <h3 className="text-sm font-medium text-red-800">{generalError}</h3>
                  </div>
                </div>
              </div>
            )}
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email address
              </label>
              <div className="mt-1">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  autoFocus
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-purple-450 focus:border-purple-450 sm:text-sm"
                />
              </div>
            </div>

            <div className="flex items-center justify-between">
              <div className="text-sm">
                <Link to="/signup" className="font-medium text-purple-450 hover:text-purple-450">
                  Create new account
                </Link>
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-purple-450 hover:bg-purple-450 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-450"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
